import { render } from "./OfSpinner.vue?vue&type=template&id=6336cd8f&scoped=true"
const script = {}

import "./OfSpinner.vue?vue&type=style&index=0&id=6336cd8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6336cd8f"]])

export default __exports__